import React from "react";
import AdminPanel from "../shared/AdminPanel";
import panelStyles from "../styles/Panel.module.css";
import styles from "../styles/ConfigEditors.module.css";

function Field({ label, hint, children }) {
  return (
    <label className={styles.field}>
      <span className={styles.fieldLabel}>{label}</span>
      {children}
      {hint ? <span className={styles.fieldHint}>{hint}</span> : null}
    </label>
  );
}

function PhotoAnimationSectionBody({ state, actions }) {
  const {
    photoAnimationConfig,
    photoAnimationLoading,
    photoAnimationSaving,
    photoAnimationDirty,
    photoAnimationUploadingIndex,
    styles: photoStyles
  } = state;

  return (
    <>
      <div className={styles.rowThree}>
        <Field
          label="Количество стилей на странице"
          hint="Сколько стилей показывать в разделе «Оживить фото» на одной странице."
        >
          <input
            type="number"
            className={panelStyles.input}
            value={Number(photoAnimationConfig?.pageSize || 5)}
            onChange={(event) => actions.updateConfig({ pageSize: Number(event.target.value) })}
            placeholder="Например: 5"
          />
        </Field>
        <Field
          label="Стоимость в токенах"
          hint="Сколько токенов списывать за одну генерацию при оплате подпиской."
        >
          <input
            type="number"
            className={panelStyles.input}
            value={Number(photoAnimationConfig?.tokenCost || 12000)}
            onChange={(event) => actions.updateConfig({ tokenCost: Number(event.target.value) })}
            placeholder="Например: 12000"
          />
        </Field>
        <Field
          label="Длительность видео, сек"
          hint="Доступные значения зависят от модели и влияют на результат."
        >
          <input
            type="number"
            className={panelStyles.input}
            value={Number(photoAnimationConfig?.durationSec || 6)}
            onChange={(event) => actions.updateConfig({ durationSec: Number(event.target.value) })}
            placeholder="6 или 10"
          />
        </Field>
      </div>

      <div className={styles.rowThree}>
        <Field
          label="Качество видео"
          hint="Разрешение результата, которое уходит в KIE для генерации."
        >
          <select
            className={panelStyles.select}
            value={String(photoAnimationConfig?.resolution || "480p")}
            onChange={(event) => actions.updateConfig({ resolution: event.target.value })}
          >
            <option value="480p">480p</option>
            <option value="720p">720p</option>
          </select>
        </Field>
        <Field
          label="Соотношение сторон"
          hint="Формат кадра для результата: горизонтальный, вертикальный или квадратный."
        >
          <select
            className={panelStyles.select}
            value={String(photoAnimationConfig?.aspectRatio || "16:9")}
            onChange={(event) => actions.updateConfig({ aspectRatio: event.target.value })}
          >
            <option value="16:9">16:9</option>
            <option value="9:16">9:16</option>
            <option value="1:1">1:1</option>
          </select>
        </Field>
        <Field
          label="ID товара для 1 видео"
          hint="Какой товар из `cost.json` использовать для разовой покупки."
        >
          <input
            type="number"
            className={panelStyles.input}
            value={Number(photoAnimationConfig?.oneTimeProductId || 18)}
            onChange={(event) => actions.updateConfig({ oneTimeProductId: Number(event.target.value) })}
            placeholder="Например: 18"
          />
        </Field>
      </div>

      <div className={styles.row}>
        <Field
          label="ID товара для пакета"
          hint="Какой товар из `cost.json` использовать для пакета из 6 видео."
        >
          <input
            type="number"
            className={panelStyles.input}
            value={Number(photoAnimationConfig?.packProductId || 19)}
            onChange={(event) => actions.updateConfig({ packProductId: Number(event.target.value) })}
            placeholder="Например: 19"
          />
        </Field>
      </div>

      <div className={styles.row}>
        <button
          type="button"
          className={panelStyles.buttonSecondary}
          onClick={actions.reload}
          disabled={photoAnimationLoading}
        >
          {photoAnimationLoading ? "Обновляем..." : "Перезагрузить"}
        </button>
        <button
          type="button"
          className={panelStyles.button}
          onClick={actions.save}
          disabled={!photoAnimationDirty || photoAnimationSaving}
        >
          {photoAnimationSaving ? "Сохраняем..." : "Сохранить"}
        </button>
      </div>

      <button type="button" className={panelStyles.buttonSecondary} onClick={actions.addStyle}>
        Добавить стиль
      </button>

      {photoStyles.length > 0 ? (
        <div className={styles.cardList}>
          {photoStyles.map((item, index) => (
            <div key={item.id || `style-${index}`} className={styles.card}>
              <div className={styles.cardHeader}>
                <strong>{item.title || `Стиль #${index + 1}`}</strong>
                <div className={styles.cardActions}>
                  <button
                    type="button"
                    className={panelStyles.buttonSecondary}
                    onClick={() => actions.moveStyle(index, "up")}
                    disabled={index === 0}
                  >
                    Вверх
                  </button>
                  <button
                    type="button"
                    className={panelStyles.buttonSecondary}
                    onClick={() => actions.moveStyle(index, "down")}
                    disabled={index === photoStyles.length - 1}
                  >
                    Вниз
                  </button>
                  <button
                    type="button"
                    className={panelStyles.buttonSecondary}
                    onClick={() => actions.removeStyle(index)}
                  >
                    Удалить
                  </button>
                </div>
              </div>

              <div className={styles.rowThree}>
                <Field label="Эмодзи стиля" hint="Короткая иконка, которая показывается в списке стилей.">
                  <input
                    type="text"
                    className={panelStyles.input}
                    value={item.emoji || "✨"}
                    placeholder="✨"
                    onChange={(event) => actions.updateStyle(index, { emoji: event.target.value })}
                  />
                </Field>
                <Field label="Название стиля" hint="Название, которое увидит пользователь в боте.">
                  <input
                    type="text"
                    className={panelStyles.input}
                    value={item.title || ""}
                    placeholder="Например: Cinematic Walk"
                    onChange={(event) => actions.updateStyle(index, { title: event.target.value })}
                  />
                </Field>
                <Field label="Статус стиля" hint="Активный стиль показывается в списке, скрытый не виден пользователю.">
                  <select
                    className={panelStyles.select}
                    value={item.active === false ? "0" : "1"}
                    onChange={(event) => actions.updateStyle(index, { active: event.target.value === "1" })}
                  >
                    <option value="1">Активен</option>
                    <option value="0">Скрыт</option>
                  </select>
                </Field>
              </div>

              <div className={styles.row}>
                <Field label="Лайки" hint="Служат для сортировки стилей в списке.">
                  <input
                    type="number"
                    className={panelStyles.input}
                    value={item.likes ?? 0}
                    placeholder="0"
                    onChange={(event) => actions.updateStyle(index, { likes: Number(event.target.value) })}
                  />
                </Field>
                <Field label="Дизлайки" hint="Тоже участвуют в сортировке и рейтинге стилей.">
                  <input
                    type="number"
                    className={panelStyles.input}
                    value={item.dislikes ?? 0}
                    placeholder="0"
                    onChange={(event) => actions.updateStyle(index, { dislikes: Number(event.target.value) })}
                  />
                </Field>
              </div>

              <Field
                label="Промпт для генерации"
                hint="Этот текст уходит в KIE и напрямую влияет на то, как будет двигаться человек на фото."
              >
                <textarea
                  rows={5}
                  className={panelStyles.textarea}
                  value={item.prompt || ""}
                  placeholder="Опиши, как должен двигаться человек на фото"
                  onChange={(event) => actions.updateStyle(index, { prompt: event.target.value })}
                />
              </Field>

              <Field
                label="Превью (фото или GIF)"
                hint="Загрузите картинку или GIF (до 20 МБ). Фото уходит в альбом VK; GIF сохраняется на сервере и отправляется в диалог как документ."
              >
                <div className={styles.row}>
                  <input
                    type="text"
                    className={panelStyles.input}
                    value={item.previewAttachment || ""}
                    placeholder="photo-... / doc-... / localgif:..."
                    onChange={(event) => actions.updateStyle(index, { previewAttachment: event.target.value })}
                  />
                  <input
                    type="file"
                    accept="image/*,.gif,image/gif"
                    onChange={(event) => {
                      const file = event.target.files && event.target.files[0] ? event.target.files[0] : null;
                      if (file) {
                        actions.uploadPreview(index, file);
                      }
                      event.target.value = "";
                    }}
                  />
                </div>
              </Field>

              <div className={panelStyles.note}>
                {photoAnimationUploadingIndex === index
                  ? "Загружаем..."
                  : item.previewAttachment || "Превью еще не загружено"}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.empty}>Стили еще не настроены.</div>
      )}
    </>
  );
}

export function PhotoAnimationSection({ mode = "panel", isOpen = true, onToggle, state, actions }) {
  if (mode === "page") {
    return <PhotoAnimationSectionBody state={state} actions={actions} />;
  }

  return (
    <AdminPanel id="photo-animation" title="Оживить фото" isOpen={isOpen} onToggle={onToggle}>
      <PhotoAnimationSectionBody state={state} actions={actions} />
    </AdminPanel>
  );
}

export default PhotoAnimationSection;
